import { Link } from 'react-router-dom';
import { getHotArticles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function HotArticles() {
  const hotArticles = getHotArticles(6);

  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              热门福利攻略
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              精选最新最热福利文章，助你轻松薅羊毛
            </p>
          </div>
          <Link
            to="/category/ecommerce"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {hotArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/ecommerce"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部福利攻略
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}